module.exports = __webpack_public_path__ + "img/Invite-amico.bd373dd8.svg";